/**
 *
 * @component 用户中心/数据看板/----总览组件
 *
 **/

import BaseCard from '@/components/UserCenter/BaseCard';
import { Select } from '&/components/AntdEncapsulation';
import { getItemData } from '@/api/personCenter/dataBoard';

import './OverviewCard.scss';

function OverviewCard(props) {
    const { defaultValue, baseParams = {}, managerOpts } = props;

    const [data, setData] = useState({});
    const [active, setActive] = useState(0);
    const [manager, setManager] = useState(null);

    useEffect(() => {
        !manager && setData(defaultValue || {});
    }, [defaultValue]);

    useEffect(() => {
        manager && reloadData(manager);
    }, [baseParams.entId]);

    const TABS = [
        {
            name: intl.get('dataBoard.projectOverview'),
            key: 0,
        },
        {
            name: intl.get('dataBoard.paymentOverview'),
            key: 1,
        },
    ];

    const onRoleChange = e => {
        setManager(e);
        reloadData(e);
    };

    function reloadData(managerId) {
        const PARAMS = { ...baseParams, managerId, div: 1 };
        if (!baseParams.entId) {
            delete PARAMS.entId; // 让axios 自带entId
        }
        getItemData(PARAMS).then(({ data }) => {
            setData(data);
        });
    }

    const filterEl = managerOpts && (
        <Select
            value={manager}
            onChange={onRoleChange}
            className="manager-select"
            showSearch
            filterOption={(input, option) =>
                (option?.label ?? '')
                    .toLowerCase()
                    .includes(input.toLowerCase())
            }
            options={managerOpts}></Select>
    );

    const formatNumber = num => {
        if (!num) return 0;
        if (Math.abs(num) < 99) {
            return num.toString();
        } else if (Math.abs(num) < 9999) {
            return Math.sign(num) * (Math.abs(num) / 1000).toFixed(2) + 'k';
        } else {
            return Math.sign(num) * (Math.abs(num) / 10000).toFixed(2) + 'w';
        }
    };

    return (
        <BaseCard
            className="overview-card"
            tabs={TABS}
            tabsProps={{ onChange: setActive }}
            headerExtra={filterEl}>
            <section className="overview-item ">
                <i className="filled icon-object"></i>
                <div className="item-content">
                    {formatNumber([data.underway, data.underwayFund][active])}
                    <div className="item-label">施工中</div>
                </div>
            </section>
            <section className="overview-item">
                <i className="filled icon-object"></i>
                <div className="item-content">
                    {formatNumber([data.month, data.monthFund][active])}
                    <div className="item-label">当月新增</div>
                </div>
            </section>
            <section className="overview-item">
                <i className="filled icon-object"></i>
                <div className="item-content">
                    {formatNumber([data.waitCheck, data.waitCheckFund][active])}
                    <div className="item-label">已完工</div>
                </div>
            </section>
        </BaseCard>
    );
}

export default OverviewCard;
